import React, { useCallback, useContext } from 'react';
import Clickable from '@prisjakt/ui-clickable';
import { RollerBlind } from '@prisjakt/ui/hideable/variants';
import RouteContext from '../../../../routes/context';
import {
  SecondaryNavigationLinkGroup,
  SecondaryNavigationLink as NavigationLinkType,
} from '../../../../types';

import * as S from './styles';

type NavigationLinkProps = {
  link: NavigationLinkType;
  property: string;
};

const NavigationLink = ({ link, property }: NavigationLinkProps) => {
  const { dispatch } = useContext(RouteContext);
  const onClickHandler = useCallback(() => {
    if (!link.indexable || !link.path) {
      dispatch({
        type: 'FILTER_LIST_UPDATE',
        property,
        id: link.id,
        clearCurrentFilters: true,
      });
    }
    window.scrollTo(0, 0);
  }, [dispatch, link.id, link.indexable, link.path, property]);
  return (
    <S.NavigationLink>
      <Clickable
        to={link.indexable && link.path ? link.path : undefined}
        onClick={onClickHandler}
      >
        {link.value}
      </Clickable>
    </S.NavigationLink>
  );
};

type NavigationTabsProps = {
  groups: SecondaryNavigationLinkGroup[];
  currentGroup: string;
};

const NavigationLinks = ({ groups, currentGroup }: NavigationTabsProps) => (
  <>
    {groups.map(({ property, links }) =>
      property && links && links.length ? (
        <RollerBlind
          key={property}
          visible={property === currentGroup}
          renderWhenHidden
        >
          <S.NavigationLinks>
            {links.map(link => (
              <NavigationLink key={link.id} link={link} property={property} />
            ))}
          </S.NavigationLinks>
        </RollerBlind>
      ) : null
    )}
  </>
);

export default NavigationLinks;
